import { render, staticRenderFns } from "./RateHistory.vue?vue&type=template&id=34b39e4a"
import script from "./RateHistory.vue?vue&type=script&lang=js"
export * from "./RateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports